module.exports = __webpack_public_path__ + "static/media/image2.4ad8436d.jpg";